import ButtonBlue from "../../components/ButtonBlue";
import styles from "./styles/overview";
import { withTranslation } from "../../i18n";

const Overview = ({ t, i18n, redirect, page_source, landingPageContent = null }) => {
    const classes = styles();

    // [Trello 399 14AUG-3] Returns null when no real percentage is available.
    // This used to fall back to 75, which is what made the CTA paint "Save 75%"
    // before the resolved value (40%) arrived.
    function formatPercentageValue(value, fallback = null) {
        if (value === null || typeof value === "undefined" || value === "") {
            return fallback;
        }

        const parsedValue = Number(value);

        if (!Number.isFinite(parsedValue)) {
            return fallback;
        }

        return parsedValue;
    }

    // Plain CTA rather than a placeholder discount.
    function buildSaveLabel(value) {
        const percentage = formatPercentageValue(value);

        if (percentage === null) {
            return t("get-started-now");
        }

        return `${t("wlan-save")} ${percentage}%`;
    }


    function getCustomButtonLabel() {
        let defaultDiscountPercentage = null;

        if (
            landingPageContent &&
            landingPageContent.highest_percentage !== null &&
            typeof landingPageContent.highest_percentage !== "undefined"
        ) {
            defaultDiscountPercentage = landingPageContent.highest_percentage;
        } else if (landingPageContent) {
            defaultDiscountPercentage = landingPageContent.discount_percentage;
        }

        switch (page_source) {
            case "/special":
            case '/redeem':
            case 'collab':
                return t('get-started-now')
            case 'promo':
            case '/deals':
                return buildSaveLabel(landingPageContent.highest_percentage)
            case 'flashdeals': {
                // Computed from rendered flashdeal packages in pages/plan/index.js.
                const flashdealsPercentage = landingPageContent && landingPageContent.highest_percentage;
                return buildSaveLabel(flashdealsPercentage);
            }
            default:
                return buildSaveLabel(defaultDiscountPercentage)
        }
    }

    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <div className={classes.textSection}>
                    <h2 className={classes.title}>
                        {t("what-are-you-waiting-for")}
                        <br />
                        <span className={classes.gradientText}>{t("try-myfitsociety-now")}</span>
                    </h2>
                    <span className={classes.description}>
                        {t("get-started-today")}
                    </span>
                    <ButtonBlue isPulse onClick={redirect} label={getCustomButtonLabel()} />
                    <div className={classes.disclaimer}>
                        *Minimum Android 9 & iOS 13
                    </div>
                </div>
                <div className={classes.imageSection}>
                    <img
                        src={`/static/new-landing-page/overview/${i18n.language}.webp`}
                        srcSet={`/static/new-landing-page/overview/${i18n.language}_440w.webp 440w, /static/new-landing-page/overview/${i18n.language}.webp ${{ id: 602, en: 603 }[i18n.language] || 603}w`}
                        sizes="(min-width: 600px) 301px, 250px"
                        loading="lazy"
                        alt="Myfitsociety App Overview"
                        className={classes.appImage}
                        width={301}
                        height={461}
                    />
                </div>
            </div>
        </div>
    );
};

export default withTranslation(["myfitsociety"])(Overview);
